export enum InheritanceSource {
    Unknown = 0,
    Category = 1,
    Company = 2,
}
